'use client';
import { useI18n } from '@/components/public/i18n/LocaleProvider';

export default function ElinaChoices({ choices, mode, selected, busy, onSelect, onReorder, onConfirm }: {
  choices: string[]; mode: 'single' | 'ranked'; selected: string[]; busy: boolean;
  onSelect: (choice: string) => void; onReorder: (choices: string[]) => void; onConfirm: () => void;
}) {
  const { t, href, content, locale } = useI18n();


  const moveUp = (index: number) => {
    const next = [...selected]; [next[index - 1], next[index]] = [next[index], next[index - 1]];
    onReorder(next);
  };
  return <div className="elina-choice-block">
    {mode === 'ranked' && <p className="elina-choice-help" id="elina-choice-help">{t("Choisissez jusqu’à trois priorités, dans l’ordre qui compte pour vous. Vous pourrez modifier cet ordre avant de valider.")}</p>}
    <div className={`elina-choices${mode === 'ranked' ? ' elina-choices-ranked' : ''}`} aria-label={mode === 'ranked' ? t('Choisir jusqu’à trois priorités') : t('Suggestions de réponse')} aria-describedby={mode === 'ranked' ? 'elina-choice-help' : undefined}>
      {choices.map(choice => <button type="button" key={choice} disabled={busy || (mode === 'ranked' && selected.length >= 3 && !selected.includes(choice))} aria-pressed={mode === 'ranked' ? selected.includes(choice) : undefined} onClick={() => onSelect(choice)}>
        {mode === 'ranked' && <span className="elina-choice-rank" aria-hidden="true">{selected.includes(choice) ? selected.indexOf(choice) + 1 : '+'}</span>}{choice}
      </button>)}
    </div>
    {mode === 'ranked' && selected.length > 0 && <div className="elina-ranked-summary">
      <p role="status">{t("Priorités choisies : {count}", { count: selected.length })}{selected.length === 3 ? t(' · Pour changer un choix, retirez-en un.') : ''}</p>
      <ol>{selected.map((choice, i) => <li key={choice}><span><strong>{i + 1}.</strong> {choice}</span><div>
        {i > 0 && <button type="button" disabled={busy} onClick={() => moveUp(i)} aria-label={t("Remonter : {choice}", { choice })}>↑</button>}
        <button type="button" disabled={busy} onClick={() => onReorder(selected.filter(s => s !== choice))} aria-label={t("Retirer la priorité : {choice}", { choice })}>×</button>
      </div></li>)}</ol>
      <button type="button" className="elina-button" disabled={busy} onClick={onConfirm}>{t("Valider ")}{selected.length > 1 ? t('mes priorités') : t('ma priorité')} →</button>
    </div>}
  </div>;
}

